/* tslint:disable */
/* eslint-disable */
/**
 * Chatbot administrace
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// Some imports not used depending on template conditions
// @ts-ignore
import { COLLECTION_FORMATS, DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import yup from '../services/ValidationService';
const patternSlovnik: any = [];
import StringAssociativeArrayInterface from '../types/StringAssociativeArrayInterface';

const paterny: StringAssociativeArrayInterface<string> = {};
patternSlovnik.map(({ pattern, description }: { pattern: string, description: string }) => paterny[`/${pattern}/`] = description);

function modelArray<T>(arr: any) {
    return arr.map((item: any) => item as T);
}

function convertValue(value: any, type: string) {
    switch(type) {
        case 'boolean':
            if(typeof value === 'string') return value === 'true';
            break
        case 'number':
        case 'integer':
            if(typeof value === 'string') return Number(value);
            break;
    }
    return value;
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface ChatDomainValidation
 */
export const ChatDomainValidation = {
    id: yup
        .number()
        .integer()
        .required()
,
    name: yup
        .string()
        //.trim()
        .max(255)
,
};

/**
 * 
 * @export
 * @interface ChatDomain
 */
export interface ChatDomain {
    /**
     * 
     * @type {number}
     * @memberof ChatDomain
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ChatDomain
     */
    name?: string;
}

export function modelChatDomain(obj: ChatDomain): ChatDomain {
    return {
        'id':
            convertValue(obj['id'], 'number'),
        'name':
            convertValue(obj['name'], 'string') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface ChatDomainBaseValidation
 */
export const ChatDomainBaseValidation = {
    name: yup
        .string()
        //.trim()
        .max(255)
,
};

/**
 * 
 * @export
 * @interface ChatDomainBase
 */
export interface ChatDomainBase {
    /**
     * 
     * @type {string}
     * @memberof ChatDomainBase
     */
    name?: string;
}

export function modelChatDomainBase(obj: ChatDomainBase): ChatDomainBase {
    return {
        'name':
            convertValue(obj['name'], 'string') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface ConfigChatbotValidation
 */
export const ConfigChatbotValidation = {
    features: yup
        .mixed()
        .nullable()
        .required()
,
    texts: yup
        .mixed()
        .nullable()
        .required()
,
    styles: yup
        .mixed()
        .nullable()
        .required()
,
};

/**
 * 
 * @export
 * @interface ConfigChatbot
 */
export interface ConfigChatbot {
    /**
     * 
     * @type {ConfigChatbotFeatures}
     * @memberof ConfigChatbot
     */
    features: ConfigChatbotFeatures;
    /**
     * 
     * @type {ConfigChatbotTexts}
     * @memberof ConfigChatbot
     */
    texts: ConfigChatbotTexts;
    /**
     * 
     * @type {ConfigChatbotStyles}
     * @memberof ConfigChatbot
     */
    styles: ConfigChatbotStyles;
}

export function modelConfigChatbot(obj: ConfigChatbot): ConfigChatbot {
    return {
        'features':
                modelConfigChatbotFeatures(obj['features'])
                
            ,
        'texts':
                modelConfigChatbotTexts(obj['texts'])
                
            ,
        'styles':
                modelConfigChatbotStyles(obj['styles'])
                
            ,
    };
}



/**
    * @export
    * @enum {string}
    */
export enum ConfigChatbotFeaturesOnChatLinkClickActionEnum {
    AutoClose = 'AutoClose',
    AutoOpen = 'AutoOpen'
}
/**
    * @export
    * @enum {string}
    */
export enum ConfigChatbotFeaturesInternalLinksTargetEnum {
    Self = 'self',
    New = 'new'
}
/**
    * @export
    * @enum {string}
    */
export enum ConfigChatbotFeaturesExternalLinksTargetEnum {
    Self = 'self',
    New = 'new'
}
/**
    * @export
    * @enum {string}
    */
export enum ConfigChatbotFeaturesCloseModeEnum {
    X = 'X',
    Expander = 'expander'
}
/**
    * @export
    * @enum {string}
    */
export enum ConfigChatbotFeaturesFooterModeEnum {
    Ris = 'RIS',
    Isr = 'ISR'
}
/**
 * Validacni schema YUP
 * 
 * @export
 * @interface ConfigChatbotFeaturesValidation
 */
export const ConfigChatbotFeaturesValidation = {
    defaultOpen: yup
        .boolean()
        .required()
,
    memoOpen: yup
        .boolean()
        .required()
,
    onChatLinkClickAction: yup
        .string()
        //.trim()
        .oneOf([
            ConfigChatbotFeaturesOnChatLinkClickActionEnum.AutoClose,
            ConfigChatbotFeaturesOnChatLinkClickActionEnum.AutoOpen,
            
        ])
,
    internalLinksTarget: yup
        .string()
        //.trim()
        .oneOf([
            ConfigChatbotFeaturesInternalLinksTargetEnum.Self,
            ConfigChatbotFeaturesInternalLinksTargetEnum.New,
            
        ])
        .required()
,
    externalLinksTarget: yup
        .string()
        //.trim()
        .oneOf([
            ConfigChatbotFeaturesExternalLinksTargetEnum.Self,
            ConfigChatbotFeaturesExternalLinksTargetEnum.New,
            
        ])
        .required()
,
    closeMode: yup
        .string()
        //.trim()
        .oneOf([
            ConfigChatbotFeaturesCloseModeEnum.X,
            ConfigChatbotFeaturesCloseModeEnum.Expander,
            
        ])
        .required()
,
    footerMode: yup
        .string()
        //.trim()
        .oneOf([
            ConfigChatbotFeaturesFooterModeEnum.Ris,
            ConfigChatbotFeaturesFooterModeEnum.Isr,
            
        ])
        .required()
,
    alertTimer: yup
        .number()
        .integer()
,
    incommingMessageShowRows: yup
        .number()
        .integer()
,
};

/**
 * 
 * @export
 * @interface ConfigChatbotFeatures
 */
export interface ConfigChatbotFeatures {
    /**
     * Výchozí rozbalenost / sbalenost chatbota
     * @type {boolean}
     * @memberof ConfigChatbotFeatures
     */
    defaultOpen: boolean;
    /**
     * Pamatování si posledního stavu rozbalenosti chatbota
     * @type {boolean}
     * @memberof ConfigChatbotFeatures
     */
    memoOpen: boolean;
    /**
     * Automatické skrývání / otevírání chatbota po kliknutí na vygenerovaný odkaz
     * @type {string}
     * @memberof ConfigChatbotFeatures
     */
    onChatLinkClickAction?: ConfigChatbotFeaturesOnChatLinkClickActionEnum;
    /**
     * Otevírání odkazů na stejné doméně ve stejném/novém okně
     * @type {string}
     * @memberof ConfigChatbotFeatures
     */
    internalLinksTarget: ConfigChatbotFeaturesInternalLinksTargetEnum;
    /**
     * Otevírání odkazů na jiné doméně ve stejném/novém okně
     * @type {string}
     * @memberof ConfigChatbotFeatures
     */
    externalLinksTarget: ConfigChatbotFeaturesExternalLinksTargetEnum;
    /**
     * Styl zavírání chatbota (křížek/ikonkou chatbota)
     * @type {string}
     * @memberof ConfigChatbotFeatures
     */
    closeMode: ConfigChatbotFeaturesCloseModeEnum;
    /**
     * Rozložení prvků v patičce chatbota
     * @type {string}
     * @memberof ConfigChatbotFeatures
     */
    footerMode: ConfigChatbotFeaturesFooterModeEnum;
    /**
     * Čas po kterém na sebe chatbot upozorní
     * @type {number}
     * @memberof ConfigChatbotFeatures
     */
    alertTimer?: number;
    /**
     * Počet řádků, které se zobrazí u příchozí zprávy.
     * @type {number}
     * @memberof ConfigChatbotFeatures
     */
    incommingMessageShowRows?: number;
}

export function modelConfigChatbotFeatures(obj: ConfigChatbotFeatures): ConfigChatbotFeatures {
    return {
        'defaultOpen':
            convertValue(obj['defaultOpen'], 'boolean'),
        'memoOpen':
            convertValue(obj['memoOpen'], 'boolean'),
        'onChatLinkClickAction':
            convertValue(obj['onChatLinkClickAction'], 'string'),
        'internalLinksTarget':
            convertValue(obj['internalLinksTarget'], 'string'),
        'externalLinksTarget':
            convertValue(obj['externalLinksTarget'], 'string'),
        'closeMode':
            convertValue(obj['closeMode'], 'string'),
        'footerMode':
            convertValue(obj['footerMode'], 'string'),
        'alertTimer':
            convertValue(obj['alertTimer'], 'number') || undefined,
        'incommingMessageShowRows':
            convertValue(obj['incommingMessageShowRows'], 'number') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface ConfigChatbotStylesValidation
 */
export const ConfigChatbotStylesValidation = {
    light: yup
        .mixed()
        .nullable()
        .required()
,
    dark: yup
        .mixed()
        .nullable()
        .required()
,
};

/**
 * 
 * @export
 * @interface ConfigChatbotStyles
 */
export interface ConfigChatbotStyles {
    /**
     * 
     * @type {StylesConfigChatbot}
     * @memberof ConfigChatbotStyles
     */
    light: StylesConfigChatbot;
    /**
     * 
     * @type {StylesConfigChatbot}
     * @memberof ConfigChatbotStyles
     */
    dark: StylesConfigChatbot;
}

export function modelConfigChatbotStyles(obj: ConfigChatbotStyles): ConfigChatbotStyles {
    return {
        'light':
                modelStylesConfigChatbot(obj['light'])
                
            ,
        'dark':
                modelStylesConfigChatbot(obj['dark'])
                
            ,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface ConfigChatbotTextsValidation
 */
export const ConfigChatbotTextsValidation = {
    name: yup
        .string()
        //.trim()
        .max(50)
        .required()
,
    btnSendTitle: yup
        .string()
        //.trim()
        .max(50)
        .required()
,
    btnRenewTitle: yup
        .string()
        //.trim()
        .max(50)
        .required()
,
    btnExpandTitle: yup
        .string()
        //.trim()
        .max(100)
        .required()
,
    btnCloseTitle: yup
        .string()
        //.trim()
        .max(100)
        .required()
,
    inputPlaceholder: yup
        .string()
        //.trim()
        .max(50)
        .required()
,
    messageRepeat: yup
        .string()
        //.trim()
        .max(50)
        .required()
,
    messageError: yup
        .string()
        //.trim()
        .max(100)
        .required()
,
    messageExpander: yup
        .string()
        //.trim()
,
    messageCollapser: yup
        .string()
        //.trim()
,
    alert: yup
        .string()
        //.trim()
,
};

/**
 * 
 * @export
 * @interface ConfigChatbotTexts
 */
export interface ConfigChatbotTexts {
    /**
     * Název chatbota, zobrazuje se v otevřeném okna navrchu
     * @type {string}
     * @memberof ConfigChatbotTexts
     */
    name: string;
    /**
     * Text tlačítka \"odeslat dotaz\", zobrazuje se po najetí myší a ve čtečce pro zrakově postižené
     * @type {string}
     * @memberof ConfigChatbotTexts
     */
    btnSendTitle: string;
    /**
     * Text tlačítka \"nová konverzace\", zobrazuje se po najetí myší a ve čtečce pro zrakově postižené
     * @type {string}
     * @memberof ConfigChatbotTexts
     */
    btnRenewTitle: string;
    /**
     * Text tlačítka \"otevřít chatbota\", zobrazuje se po najetí myší a ve čtečce pro zrakově postižené
     * @type {string}
     * @memberof ConfigChatbotTexts
     */
    btnExpandTitle: string;
    /**
     * Text tlačítka \"schovat chatbota\", zobrazuje se po najetí myší a ve čtečce pro zrakově postižené
     * @type {string}
     * @memberof ConfigChatbotTexts
     */
    btnCloseTitle: string;
    /**
     * Placeholder políčka pro psaní dotazu
     * @type {string}
     * @memberof ConfigChatbotTexts
     */
    inputPlaceholder: string;
    /**
     * Text zobrazující se pod bublinou v chatu, když se nepodaří získat odpověď ze serveru. Vedle textu je refresh ikonka, která po kliknutí opakuje dotaz. Něco ve stylu \"odeslat znovu\"
     * @type {string}
     * @memberof ConfigChatbotTexts
     */
    messageRepeat: string;
    /**
     * Text zobrazující se v bublině chatu, když se nepodaří získat odpověď ze serveru. Něco ve stylu \"Teď nemohu odpovědět, zeptejte se mě později…\" nebo \"Jejda, něco se nepovedlo\"
     * @type {string}
     * @memberof ConfigChatbotTexts
     */
    messageError: string;
    /**
     * Text zobrazující se v bublině chatu, když je text příliš dlouhý. Rozbalovátko
     * @type {string}
     * @memberof ConfigChatbotTexts
     */
    messageExpander?: string;
    /**
     * Text zobrazující se v bublině chatu, když je text příliš dlouhý. Sbalovátko
     * @type {string}
     * @memberof ConfigChatbotTexts
     */
    messageCollapser?: string;
    /**
     * Text zobrazující se v bublině, když na sebe chatbot upozorňuje
     * @type {string}
     * @memberof ConfigChatbotTexts
     */
    alert?: string;
}

export function modelConfigChatbotTexts(obj: ConfigChatbotTexts): ConfigChatbotTexts {
    return {
        'name':
            convertValue(obj['name'], 'string'),
        'btnSendTitle':
            convertValue(obj['btnSendTitle'], 'string'),
        'btnRenewTitle':
            convertValue(obj['btnRenewTitle'], 'string'),
        'btnExpandTitle':
            convertValue(obj['btnExpandTitle'], 'string'),
        'btnCloseTitle':
            convertValue(obj['btnCloseTitle'], 'string'),
        'inputPlaceholder':
            convertValue(obj['inputPlaceholder'], 'string'),
        'messageRepeat':
            convertValue(obj['messageRepeat'], 'string'),
        'messageError':
            convertValue(obj['messageError'], 'string'),
        'messageExpander':
            convertValue(obj['messageExpander'], 'string') || undefined,
        'messageCollapser':
            convertValue(obj['messageCollapser'], 'string') || undefined,
        'alert':
            convertValue(obj['alert'], 'string') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface ConversationValidation
 */
export const ConversationValidation = {
    sessionId: yup
        .string()
        //.trim()
        .required()
,
    userId: yup
        .string()
        //.trim()
,
    lastMessage: yup
        .string()
        //.trim()
,
    hasUnreadMessage: yup
        .boolean()
,
    assignedUserId: yup
        .number()
        .integer()
,
};

/**
 * 
 * @export
 * @interface Conversation
 */
export interface Conversation {
    /**
     * The unique identifier for the session
     * @type {string}
     * @memberof Conversation
     */
    sessionId: string;
    /**
     * Identifier of user
     * @type {string}
     * @memberof Conversation
     */
    userId?: string;
    /**
     * Last message of conversation
     * @type {string}
     * @memberof Conversation
     */
    lastMessage?: string;
    /**
     * Conversation does have a new unread message
     * @type {boolean}
     * @memberof Conversation
     */
    hasUnreadMessage?: boolean;
    /**
     * Identifier of user assigned to conversation
     * @type {number}
     * @memberof Conversation
     */
    assignedUserId?: number;
}

export function modelConversation(obj: Conversation): Conversation {
    return {
        'sessionId':
            convertValue(obj['sessionId'], 'string'),
        'userId':
            convertValue(obj['userId'], 'string') || undefined,
        'lastMessage':
            convertValue(obj['lastMessage'], 'string') || undefined,
        'hasUnreadMessage':
            convertValue(obj['hasUnreadMessage'], 'boolean') || undefined,
        'assignedUserId':
            convertValue(obj['assignedUserId'], 'number') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface ConversationBaseValidation
 */
export const ConversationBaseValidation = {
    sessionId: yup
        .string()
        //.trim()
        .required()
,
    userId: yup
        .string()
        //.trim()
,
    lastMessage: yup
        .string()
        //.trim()
,
    hasUnreadMessage: yup
        .boolean()
,
    assignedUserId: yup
        .number()
        .integer()
,
};

/**
 * 
 * @export
 * @interface ConversationBase
 */
export interface ConversationBase {
    /**
     * The unique identifier for the session
     * @type {string}
     * @memberof ConversationBase
     */
    sessionId: string;
    /**
     * Identifier of user
     * @type {string}
     * @memberof ConversationBase
     */
    userId?: string;
    /**
     * Last message of conversation
     * @type {string}
     * @memberof ConversationBase
     */
    lastMessage?: string;
    /**
     * Conversation does have a new unread message
     * @type {boolean}
     * @memberof ConversationBase
     */
    hasUnreadMessage?: boolean;
    /**
     * Identifier of user assigned to conversation
     * @type {number}
     * @memberof ConversationBase
     */
    assignedUserId?: number;
}

export function modelConversationBase(obj: ConversationBase): ConversationBase {
    return {
        'sessionId':
            convertValue(obj['sessionId'], 'string'),
        'userId':
            convertValue(obj['userId'], 'string') || undefined,
        'lastMessage':
            convertValue(obj['lastMessage'], 'string') || undefined,
        'hasUnreadMessage':
            convertValue(obj['hasUnreadMessage'], 'boolean') || undefined,
        'assignedUserId':
            convertValue(obj['assignedUserId'], 'number') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface ConversationDetailValidation
 */
export const ConversationDetailValidation = {
    userId: yup
        .string()
        //.trim()
,
    messages: yup
        .array()
        .nullable()
,
};

/**
 * 
 * @export
 * @interface ConversationDetail
 */
export interface ConversationDetail {
    /**
     * The unique identifier of session user
     * @type {string}
     * @memberof ConversationDetail
     */
    userId?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof ConversationDetail
     */
    messages?: Array<object>;
}

export function modelConversationDetail(obj: ConversationDetail): ConversationDetail {
    return {
        'userId':
            convertValue(obj['userId'], 'string') || undefined,
        'messages':
            convertValue(obj['messages'], 'Array<object>') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface CsLpUzelValidation
 */
export const CsLpUzelValidation = {
    id: yup
        .number()
        .integer()
        .required()
,
    shorttext: yup
        .string()
        //.trim()
        .max(255)
,
    longtext: yup
        .string()
        //.trim()
        .max(2000)
,
    aditional_information: yup
        .string()
        //.trim()
,
    child: yup
        .array()
        .nullable()
,
};

/**
 * 
 * @export
 * @interface CsLpUzel
 */
export interface CsLpUzel {
    /**
     * 
     * @type {number}
     * @memberof CsLpUzel
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CsLpUzel
     */
    shorttext?: string;
    /**
     * 
     * @type {string}
     * @memberof CsLpUzel
     */
    longtext?: string;
    /**
     * 
     * @type {string}
     * @memberof CsLpUzel
     */
    aditional_information?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CsLpUzel
     */
    child?: Array<number>;
}

export function modelCsLpUzel(obj: CsLpUzel): CsLpUzel {
    return {
        'id':
            convertValue(obj['id'], 'number'),
        'shorttext':
            convertValue(obj['shorttext'], 'string') || undefined,
        'longtext':
            convertValue(obj['longtext'], 'string') || undefined,
        'aditional_information':
            convertValue(obj['aditional_information'], 'string') || undefined,
        'child':
            convertValue(obj['child'], 'Array<number>') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface CsLpUzelBaseValidation
 */
export const CsLpUzelBaseValidation = {
    shorttext: yup
        .string()
        //.trim()
        .max(255)
,
    longtext: yup
        .string()
        //.trim()
        .max(2000)
,
    aditional_information: yup
        .string()
        //.trim()
,
};

/**
 * 
 * @export
 * @interface CsLpUzelBase
 */
export interface CsLpUzelBase {
    /**
     * 
     * @type {string}
     * @memberof CsLpUzelBase
     */
    shorttext?: string;
    /**
     * 
     * @type {string}
     * @memberof CsLpUzelBase
     */
    longtext?: string;
    /**
     * 
     * @type {string}
     * @memberof CsLpUzelBase
     */
    aditional_information?: string;
}

export function modelCsLpUzelBase(obj: CsLpUzelBase): CsLpUzelBase {
    return {
        'shorttext':
            convertValue(obj['shorttext'], 'string') || undefined,
        'longtext':
            convertValue(obj['longtext'], 'string') || undefined,
        'aditional_information':
            convertValue(obj['aditional_information'], 'string') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface CsLpUzelCreateValidation
 */
export const CsLpUzelCreateValidation = {
    shorttext: yup
        .string()
        //.trim()
        .max(255)
,
    longtext: yup
        .string()
        //.trim()
        .max(2000)
,
    aditional_information: yup
        .string()
        //.trim()
,
    parentId: yup
        .number()
        .integer()
,
};

/**
 * 
 * @export
 * @interface CsLpUzelCreate
 */
export interface CsLpUzelCreate {
    /**
     * 
     * @type {string}
     * @memberof CsLpUzelCreate
     */
    shorttext?: string;
    /**
     * 
     * @type {string}
     * @memberof CsLpUzelCreate
     */
    longtext?: string;
    /**
     * 
     * @type {string}
     * @memberof CsLpUzelCreate
     */
    aditional_information?: string;
    /**
     * Nový number atribut
     * @type {number}
     * @memberof CsLpUzelCreate
     */
    parentId?: number;
}

export function modelCsLpUzelCreate(obj: CsLpUzelCreate): CsLpUzelCreate {
    return {
        'shorttext':
            convertValue(obj['shorttext'], 'string') || undefined,
        'longtext':
            convertValue(obj['longtext'], 'string') || undefined,
        'aditional_information':
            convertValue(obj['aditional_information'], 'string') || undefined,
        'parentId':
            convertValue(obj['parentId'], 'number') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface CsLpUzelCreateAllOfValidation
 */
export const CsLpUzelCreateAllOfValidation = {
    parentId: yup
        .number()
        .integer()
,
};

/**
 * 
 * @export
 * @interface CsLpUzelCreateAllOf
 */
export interface CsLpUzelCreateAllOf {
    /**
     * Nový number atribut
     * @type {number}
     * @memberof CsLpUzelCreateAllOf
     */
    parentId?: number;
}

export function modelCsLpUzelCreateAllOf(obj: CsLpUzelCreateAllOf): CsLpUzelCreateAllOf {
    return {
        'parentId':
            convertValue(obj['parentId'], 'number') || undefined,
    };
}


/**
 * Validacni schema YUP
 * Objekt ciste kvuli validaci formulare
 * @export
 * @interface CsLpUzelNovyPotomekValidation
 */
export const CsLpUzelNovyPotomekValidation = {
    novyPotomekId: yup
        .number()
        .integer()
        .required()
,
};

/**
 * Objekt ciste kvuli validaci formulare
 * @export
 * @interface CsLpUzelNovyPotomek
 */
export interface CsLpUzelNovyPotomek {
    /**
     * 
     * @type {number}
     * @memberof CsLpUzelNovyPotomek
     */
    novyPotomekId: number;
}

export function modelCsLpUzelNovyPotomek(obj: CsLpUzelNovyPotomek): CsLpUzelNovyPotomek {
    return {
        'novyPotomekId':
            convertValue(obj['novyPotomekId'], 'number'),
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface CsLpUzelUpdateValidation
 */
export const CsLpUzelUpdateValidation = {
    shorttext: yup
        .string()
        //.trim()
        .max(255)
,
    longtext: yup
        .string()
        //.trim()
        .max(2000)
,
    aditional_information: yup
        .string()
        //.trim()
,
    child: yup
        .array()
        .nullable()
,
};

/**
 * 
 * @export
 * @interface CsLpUzelUpdate
 */
export interface CsLpUzelUpdate {
    /**
     * 
     * @type {string}
     * @memberof CsLpUzelUpdate
     */
    shorttext?: string;
    /**
     * 
     * @type {string}
     * @memberof CsLpUzelUpdate
     */
    longtext?: string;
    /**
     * 
     * @type {string}
     * @memberof CsLpUzelUpdate
     */
    aditional_information?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CsLpUzelUpdate
     */
    child?: Array<number>;
}

export function modelCsLpUzelUpdate(obj: CsLpUzelUpdate): CsLpUzelUpdate {
    return {
        'shorttext':
            convertValue(obj['shorttext'], 'string') || undefined,
        'longtext':
            convertValue(obj['longtext'], 'string') || undefined,
        'aditional_information':
            convertValue(obj['aditional_information'], 'string') || undefined,
        'child':
            convertValue(obj['child'], 'Array<number>') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface CsLpUzelUpdateAllOfValidation
 */
export const CsLpUzelUpdateAllOfValidation = {
    child: yup
        .array()
        .nullable()
,
};

/**
 * 
 * @export
 * @interface CsLpUzelUpdateAllOf
 */
export interface CsLpUzelUpdateAllOf {
    /**
     * 
     * @type {Array<number>}
     * @memberof CsLpUzelUpdateAllOf
     */
    child?: Array<number>;
}

export function modelCsLpUzelUpdateAllOf(obj: CsLpUzelUpdateAllOf): CsLpUzelUpdateAllOf {
    return {
        'child':
            convertValue(obj['child'], 'Array<number>') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface FaqValidation
 */
export const FaqValidation = {
    id: yup
        .number()
        .integer()
        .required()
,
    node_id: yup
        .number()
        .integer()
,
    answer: yup
        .string()
        //.trim()
        .min(1)
,
    domain_id: yup
        .number()
        .integer()
,
};

/**
 * 
 * @export
 * @interface Faq
 */
export interface Faq {
    /**
     * 
     * @type {number}
     * @memberof Faq
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof Faq
     */
    node_id?: number;
    /**
     * 
     * @type {string}
     * @memberof Faq
     */
    answer?: string;
    /**
     * 
     * @type {number}
     * @memberof Faq
     */
    domain_id?: number;
}

export function modelFaq(obj: Faq): Faq {
    return {
        'id':
            convertValue(obj['id'], 'number'),
        'node_id':
            convertValue(obj['node_id'], 'number') || undefined,
        'answer':
            convertValue(obj['answer'], 'string') || undefined,
        'domain_id':
            convertValue(obj['domain_id'], 'number') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface FaqBaseValidation
 */
export const FaqBaseValidation = {
    node_id: yup
        .number()
        .integer()
,
    answer: yup
        .string()
        //.trim()
        .min(1)
,
    domain_id: yup
        .number()
        .integer()
,
};

/**
 * 
 * @export
 * @interface FaqBase
 */
export interface FaqBase {
    /**
     * 
     * @type {number}
     * @memberof FaqBase
     */
    node_id?: number;
    /**
     * 
     * @type {string}
     * @memberof FaqBase
     */
    answer?: string;
    /**
     * 
     * @type {number}
     * @memberof FaqBase
     */
    domain_id?: number;
}

export function modelFaqBase(obj: FaqBase): FaqBase {
    return {
        'node_id':
            convertValue(obj['node_id'], 'number') || undefined,
        'answer':
            convertValue(obj['answer'], 'string') || undefined,
        'domain_id':
            convertValue(obj['domain_id'], 'number') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface FaqQuestionsValidation
 */
export const FaqQuestionsValidation = {
    id: yup
        .number()
        .integer()
        .required()
,
    question: yup
        .string()
        //.trim()
        .min(1)
,
    parent_answer_id: yup
        .number()
        .integer()
,
};

/**
 * 
 * @export
 * @interface FaqQuestions
 */
export interface FaqQuestions {
    /**
     * 
     * @type {number}
     * @memberof FaqQuestions
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FaqQuestions
     */
    question?: string;
    /**
     * 
     * @type {number}
     * @memberof FaqQuestions
     */
    parent_answer_id?: number;
}

export function modelFaqQuestions(obj: FaqQuestions): FaqQuestions {
    return {
        'id':
            convertValue(obj['id'], 'number'),
        'question':
            convertValue(obj['question'], 'string') || undefined,
        'parent_answer_id':
            convertValue(obj['parent_answer_id'], 'number') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface FaqQuestionsBaseValidation
 */
export const FaqQuestionsBaseValidation = {
    question: yup
        .string()
        //.trim()
        .min(1)
,
    parent_answer_id: yup
        .number()
        .integer()
,
};

/**
 * 
 * @export
 * @interface FaqQuestionsBase
 */
export interface FaqQuestionsBase {
    /**
     * 
     * @type {string}
     * @memberof FaqQuestionsBase
     */
    question?: string;
    /**
     * 
     * @type {number}
     * @memberof FaqQuestionsBase
     */
    parent_answer_id?: number;
}

export function modelFaqQuestionsBase(obj: FaqQuestionsBase): FaqQuestionsBase {
    return {
        'question':
            convertValue(obj['question'], 'string') || undefined,
        'parent_answer_id':
            convertValue(obj['parent_answer_id'], 'number') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface ForbValidation
 */
export const ForbValidation = {
    id: yup
        .number()
        .integer()
        .required()
,
    answer: yup
        .string()
        //.trim()
        .min(1)
,
};

/**
 * 
 * @export
 * @interface Forb
 */
export interface Forb {
    /**
     * 
     * @type {number}
     * @memberof Forb
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Forb
     */
    answer?: string;
}

export function modelForb(obj: Forb): Forb {
    return {
        'id':
            convertValue(obj['id'], 'number'),
        'answer':
            convertValue(obj['answer'], 'string') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface ForbBaseValidation
 */
export const ForbBaseValidation = {
    answer: yup
        .string()
        //.trim()
        .min(1)
,
};

/**
 * 
 * @export
 * @interface ForbBase
 */
export interface ForbBase {
    /**
     * 
     * @type {string}
     * @memberof ForbBase
     */
    answer?: string;
}

export function modelForbBase(obj: ForbBase): ForbBase {
    return {
        'answer':
            convertValue(obj['answer'], 'string') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface ForbQuestionValidation
 */
export const ForbQuestionValidation = {
    id: yup
        .number()
        .integer()
        .required()
,
    question: yup
        .string()
        //.trim()
        .min(1)
,
    parent_answer_id: yup
        .number()
        .integer()
        .min(1)
,
};

/**
 * 
 * @export
 * @interface ForbQuestion
 */
export interface ForbQuestion {
    /**
     * 
     * @type {number}
     * @memberof ForbQuestion
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ForbQuestion
     */
    question?: string;
    /**
     * 
     * @type {number}
     * @memberof ForbQuestion
     */
    parent_answer_id?: number;
}

export function modelForbQuestion(obj: ForbQuestion): ForbQuestion {
    return {
        'id':
            convertValue(obj['id'], 'number'),
        'question':
            convertValue(obj['question'], 'string') || undefined,
        'parent_answer_id':
            convertValue(obj['parent_answer_id'], 'number') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface ForbQuestionBaseValidation
 */
export const ForbQuestionBaseValidation = {
    question: yup
        .string()
        //.trim()
        .min(1)
,
    parent_answer_id: yup
        .number()
        .integer()
        .min(1)
,
};

/**
 * 
 * @export
 * @interface ForbQuestionBase
 */
export interface ForbQuestionBase {
    /**
     * 
     * @type {string}
     * @memberof ForbQuestionBase
     */
    question?: string;
    /**
     * 
     * @type {number}
     * @memberof ForbQuestionBase
     */
    parent_answer_id?: number;
}

export function modelForbQuestionBase(obj: ForbQuestionBase): ForbQuestionBase {
    return {
        'question':
            convertValue(obj['question'], 'string') || undefined,
        'parent_answer_id':
            convertValue(obj['parent_answer_id'], 'number') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface IdentificatorValidation
 */
export const IdentificatorValidation = {
    id: yup
        .number()
        .integer()
        .required()
,
};

/**
 * 
 * @export
 * @interface Identificator
 */
export interface Identificator {
    /**
     * 
     * @type {number}
     * @memberof Identificator
     */
    id: number;
}

export function modelIdentificator(obj: Identificator): Identificator {
    return {
        'id':
            convertValue(obj['id'], 'number'),
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface InlineObjectValidation
 */
export const InlineObjectValidation = {
    assignUserId: yup
        .number()
        .integer()
,
};

/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * Identifikator operatora, kteremu se ma konverzace priradit
     * @type {number}
     * @memberof InlineObject
     */
    assignUserId?: number;
}

export function modelInlineObject(obj: InlineObject): InlineObject {
    return {
        'assignUserId':
            convertValue(obj['assignUserId'], 'number') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface InternalServerErrorValidation
 */
export const InternalServerErrorValidation = {
    errorId: yup
        .string()
        //.trim()
        .max(255)
        .required()
,
    message: yup
        .string()
        //.trim()
        .required()
,
};

/**
 * 
 * @export
 * @interface InternalServerError
 */
export interface InternalServerError {
    /**
     * 
     * @type {string}
     * @memberof InternalServerError
     */
    errorId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalServerError
     */
    message: string;
}

export function modelInternalServerError(obj: InternalServerError): InternalServerError {
    return {
        'errorId':
            convertValue(obj['errorId'], 'string'),
        'message':
            convertValue(obj['message'], 'string'),
    };
}



/**
    * @export
    * @enum {string}
    */
export enum InvalidInputLevelEnum {
    Warning = 'warning',
    Error = 'error'
}
/**
 * Validacni schema YUP
 * 
 * @export
 * @interface InvalidInputValidation
 */
export const InvalidInputValidation = {
    errorId: yup
        .string()
        //.trim()
        .max(255)
        .required()
,
    message: yup
        .string()
        //.trim()
        .required()
,
    level: yup
        .string()
        //.trim()
        .oneOf([
            InvalidInputLevelEnum.Warning,
            InvalidInputLevelEnum.Error,
            
        ])
        .required()
,
};

/**
 * 
 * @export
 * @interface InvalidInput
 */
export interface InvalidInput {
    /**
     * 
     * @type {string}
     * @memberof InvalidInput
     */
    errorId: string;
    /**
     * 
     * @type {string}
     * @memberof InvalidInput
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof InvalidInput
     */
    level: InvalidInputLevelEnum;
}

export function modelInvalidInput(obj: InvalidInput): InvalidInput {
    return {
        'errorId':
            convertValue(obj['errorId'], 'string'),
        'message':
            convertValue(obj['message'], 'string'),
        'level':
            convertValue(obj['level'], 'string'),
    };
}



/**
    * @export
    * @enum {string}
    */
export enum InvalidInputAllOfLevelEnum {
    Warning = 'warning',
    Error = 'error'
}
/**
 * Validacni schema YUP
 * 
 * @export
 * @interface InvalidInputAllOfValidation
 */
export const InvalidInputAllOfValidation = {
    level: yup
        .string()
        //.trim()
        .oneOf([
            InvalidInputAllOfLevelEnum.Warning,
            InvalidInputAllOfLevelEnum.Error,
            
        ])
        .required()
,
};

/**
 * 
 * @export
 * @interface InvalidInputAllOf
 */
export interface InvalidInputAllOf {
    /**
     * 
     * @type {string}
     * @memberof InvalidInputAllOf
     */
    level: InvalidInputAllOfLevelEnum;
}

export function modelInvalidInputAllOf(obj: InvalidInputAllOf): InvalidInputAllOf {
    return {
        'level':
            convertValue(obj['level'], 'string'),
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface PrihlasovaciHesloValidation
 */
export const PrihlasovaciHesloValidation = {
    password: yup
        .string()
        //.trim()
        .min(5)
        .max(255)
        .required()
,
};

/**
 * 
 * @export
 * @interface PrihlasovaciHeslo
 */
export interface PrihlasovaciHeslo {
    /**
     * 
     * @type {string}
     * @memberof PrihlasovaciHeslo
     */
    password: string;
}

export function modelPrihlasovaciHeslo(obj: PrihlasovaciHeslo): PrihlasovaciHeslo {
    return {
        'password':
            convertValue(obj['password'], 'string'),
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface PrihlasovaciJmenoValidation
 */
export const PrihlasovaciJmenoValidation = {
    username: yup
        .string()
        //.trim()
        .min(1)
        .max(20)
        .required()
,
};

/**
 * 
 * @export
 * @interface PrihlasovaciJmeno
 */
export interface PrihlasovaciJmeno {
    /**
     * 
     * @type {string}
     * @memberof PrihlasovaciJmeno
     */
    username: string;
}

export function modelPrihlasovaciJmeno(obj: PrihlasovaciJmeno): PrihlasovaciJmeno {
    return {
        'username':
            convertValue(obj['username'], 'string'),
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface PrihlasovaciUdajeValidation
 */
export const PrihlasovaciUdajeValidation = {
    username: yup
        .string()
        //.trim()
        .min(1)
        .max(20)
        .required()
,
    password: yup
        .string()
        //.trim()
        .min(5)
        .max(255)
        .required()
,
};

/**
 * 
 * @export
 * @interface PrihlasovaciUdaje
 */
export interface PrihlasovaciUdaje {
    /**
     * 
     * @type {string}
     * @memberof PrihlasovaciUdaje
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof PrihlasovaciUdaje
     */
    password: string;
}

export function modelPrihlasovaciUdaje(obj: PrihlasovaciUdaje): PrihlasovaciUdaje {
    return {
        'username':
            convertValue(obj['username'], 'string'),
        'password':
            convertValue(obj['password'], 'string'),
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface SmalltalkValidation
 */
export const SmalltalkValidation = {
    id: yup
        .number()
        .integer()
        .required()
,
    answer: yup
        .string()
        //.trim()
        .min(1)
,
};

/**
 * 
 * @export
 * @interface Smalltalk
 */
export interface Smalltalk {
    /**
     * 
     * @type {number}
     * @memberof Smalltalk
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Smalltalk
     */
    answer?: string;
}

export function modelSmalltalk(obj: Smalltalk): Smalltalk {
    return {
        'id':
            convertValue(obj['id'], 'number'),
        'answer':
            convertValue(obj['answer'], 'string') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface SmalltalkBaseValidation
 */
export const SmalltalkBaseValidation = {
    answer: yup
        .string()
        //.trim()
        .min(1)
,
};

/**
 * 
 * @export
 * @interface SmalltalkBase
 */
export interface SmalltalkBase {
    /**
     * 
     * @type {string}
     * @memberof SmalltalkBase
     */
    answer?: string;
}

export function modelSmalltalkBase(obj: SmalltalkBase): SmalltalkBase {
    return {
        'answer':
            convertValue(obj['answer'], 'string') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface SmalltalkQuestionValidation
 */
export const SmalltalkQuestionValidation = {
    id: yup
        .number()
        .integer()
        .required()
,
    question: yup
        .string()
        //.trim()
        .min(1)
,
    parent_answer_id: yup
        .number()
        .integer()
,
};

/**
 * 
 * @export
 * @interface SmalltalkQuestion
 */
export interface SmalltalkQuestion {
    /**
     * 
     * @type {number}
     * @memberof SmalltalkQuestion
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SmalltalkQuestion
     */
    question?: string;
    /**
     * 
     * @type {number}
     * @memberof SmalltalkQuestion
     */
    parent_answer_id?: number;
}

export function modelSmalltalkQuestion(obj: SmalltalkQuestion): SmalltalkQuestion {
    return {
        'id':
            convertValue(obj['id'], 'number'),
        'question':
            convertValue(obj['question'], 'string') || undefined,
        'parent_answer_id':
            convertValue(obj['parent_answer_id'], 'number') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface SmalltalkQuestionBaseValidation
 */
export const SmalltalkQuestionBaseValidation = {
    question: yup
        .string()
        //.trim()
        .min(1)
,
    parent_answer_id: yup
        .number()
        .integer()
,
};

/**
 * 
 * @export
 * @interface SmalltalkQuestionBase
 */
export interface SmalltalkQuestionBase {
    /**
     * 
     * @type {string}
     * @memberof SmalltalkQuestionBase
     */
    question?: string;
    /**
     * 
     * @type {number}
     * @memberof SmalltalkQuestionBase
     */
    parent_answer_id?: number;
}

export function modelSmalltalkQuestionBase(obj: SmalltalkQuestionBase): SmalltalkQuestionBase {
    return {
        'question':
            convertValue(obj['question'], 'string') || undefined,
        'parent_answer_id':
            convertValue(obj['parent_answer_id'], 'number') || undefined,
    };
}


/**
 * Validacni schema YUP
 * 
 * @export
 * @interface StylesConfigChatbotValidation
 */
export const StylesConfigChatbotValidation = {
    logoImage: yup
        .mixed()
        .nullable()
,
    fontFamily: yup
        .string()
        //.trim()
        .required()
,
    iconImage: yup
        .string()
        //.trim()
        .max(41)
        .required()
,
    iconBgColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    windowBgColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    nameColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    nameBgColor: yup
        .string()
        //.trim()
        .required()
,
    btnSendBgColor: yup
        .string()
        //.trim()
        .required()
,
    btnSendColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    btnSendImage: yup
        .string()
        //.trim()
,
    btnRenewBgColor: yup
        .string()
        //.trim()
        .required()
,
    btnRenewColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    btnRenewImage: yup
        .string()
        //.trim()
,
    inputBgColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    inputTextColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    messageInBgColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    messageInTextColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    messageInImage: yup
        .string()
        //.trim()
,
    messageOutBgColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    messageOutTextColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    messageOutImage: yup
        .string()
        //.trim()
,
    messageErrorColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    messageInfoColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    faqBgColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    faqTextColor: yup
        .string()
        //.trim()
        .max(7)
        .required()
,
    footerBgColor: yup
        .string()
        //.trim()
        .required()
,
};

/**
 * 
 * @export
 * @interface StylesConfigChatbot
 */
export interface StylesConfigChatbot {
    /**
     * Nazev souboru s logem zákazníka
     * @type {any}
     * @memberof StylesConfigChatbot
     */
    logoImage?: any | null;
    /**
     * Font chatbota
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    fontFamily: string;
    /**
     * Nazev souboru s ikonkou chatbota
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    iconImage: string;
    /**
     * Barva pozadí za rozbalovací ikonkou chatbota
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    iconBgColor: string;
    /**
     * Barva pozadí okna
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    windowBgColor: string;
    /**
     * Barva písma názvu chatbota
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    nameColor: string;
    /**
     * Barva pozadí názvu chatbota
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    nameBgColor: string;
    /**
     * Barva pozadí tlačítka \"odeslat zprávu\"
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    btnSendBgColor: string;
    /**
     * Barva ikonky tlačítka \"odeslat zprávu\"
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    btnSendColor: string;
    /**
     * Ikonka tlačítka \"odeslat zprávu\"
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    btnSendImage?: string;
    /**
     * Barva pozadí tlačítka \"nová konverzace\"
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    btnRenewBgColor: string;
    /**
     * Barva ikonky tlačítka \"nová konverzace\"
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    btnRenewColor: string;
    /**
     * Ikonka tlačítka \"nová konverzace\"
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    btnRenewImage?: string;
    /**
     * Barva pozadí políčka pro psaní zprávy
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    inputBgColor: string;
    /**
     * Barva textu políčka pro psaní zprávy
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    inputTextColor: string;
    /**
     * Barva pozadí bubliny s příchozí zprávou
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    messageInBgColor: string;
    /**
     * Barva textu bubliny s příchozí zprávou
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    messageInTextColor: string;
    /**
     * Obrázek vedle bubliny s příchozí zprávou
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    messageInImage?: string;
    /**
     * Barva pozadí bubliny s odchozí zprávou
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    messageOutBgColor: string;
    /**
     * Barva textu bubliny s odchozí zprávou
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    messageOutTextColor: string;
    /**
     * Obrázek vedle bubliny s odchozí zprávou
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    messageOutImage?: string;
    /**
     * Barva textu chybové zprávy pod bublinou, když se nezdaří získat odpověď ze serveru.
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    messageErrorColor: string;
    /**
     * Barva textu info zprávy typu \"připojil se operátor\"
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    messageInfoColor: string;
    /**
     * Barva pozadí bubliny s FAQ
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    faqBgColor: string;
    /**
     * Barva textu bubliny s FAQ
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    faqTextColor: string;
    /**
     * Barva pozadí patičky
     * @type {string}
     * @memberof StylesConfigChatbot
     */
    footerBgColor: string;
}

export function modelStylesConfigChatbot(obj: StylesConfigChatbot): StylesConfigChatbot {
    return {
        'logoImage':
            convertValue(obj['logoImage'], 'any') || undefined,
        'fontFamily':
            convertValue(obj['fontFamily'], 'string'),
        'iconImage':
            convertValue(obj['iconImage'], 'string'),
        'iconBgColor':
            convertValue(obj['iconBgColor'], 'string'),
        'windowBgColor':
            convertValue(obj['windowBgColor'], 'string'),
        'nameColor':
            convertValue(obj['nameColor'], 'string'),
        'nameBgColor':
            convertValue(obj['nameBgColor'], 'string'),
        'btnSendBgColor':
            convertValue(obj['btnSendBgColor'], 'string'),
        'btnSendColor':
            convertValue(obj['btnSendColor'], 'string'),
        'btnSendImage':
            convertValue(obj['btnSendImage'], 'string') || undefined,
        'btnRenewBgColor':
            convertValue(obj['btnRenewBgColor'], 'string'),
        'btnRenewColor':
            convertValue(obj['btnRenewColor'], 'string'),
        'btnRenewImage':
            convertValue(obj['btnRenewImage'], 'string') || undefined,
        'inputBgColor':
            convertValue(obj['inputBgColor'], 'string'),
        'inputTextColor':
            convertValue(obj['inputTextColor'], 'string'),
        'messageInBgColor':
            convertValue(obj['messageInBgColor'], 'string'),
        'messageInTextColor':
            convertValue(obj['messageInTextColor'], 'string'),
        'messageInImage':
            convertValue(obj['messageInImage'], 'string') || undefined,
        'messageOutBgColor':
            convertValue(obj['messageOutBgColor'], 'string'),
        'messageOutTextColor':
            convertValue(obj['messageOutTextColor'], 'string'),
        'messageOutImage':
            convertValue(obj['messageOutImage'], 'string') || undefined,
        'messageErrorColor':
            convertValue(obj['messageErrorColor'], 'string'),
        'messageInfoColor':
            convertValue(obj['messageInfoColor'], 'string'),
        'faqBgColor':
            convertValue(obj['faqBgColor'], 'string'),
        'faqTextColor':
            convertValue(obj['faqTextColor'], 'string'),
        'footerBgColor':
            convertValue(obj['footerBgColor'], 'string'),
    };
}


/**
 * 
 * @summary Prihlaseni uzivatele, ziskani pristupoveho tokenu
 * @param {PrihlasovaciUdaje} prihlasovaciUdaje 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const uzivatelPrihlaseni = (prihlasovaciUdaje: PrihlasovaciUdaje, options: any = {}): any => {
    // verify required parameter 'prihlasovaciUdaje' is not null or undefined
    assertParamExists('uzivatelPrihlaseni', 'prihlasovaciUdaje', prihlasovaciUdaje)
    const localVarPath = `/uzivatel/prihlaseni`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'POST', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelPrihlasovaciUdaje(prihlasovaciUdaje), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}



/**
 * 
 * @summary Vytvořit nový CHAT_DOMAIN
 * @param {ChatDomainBase} chatDomainBase 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const chatDomainCreate = (chatDomainBase: ChatDomainBase, options: any = {}): any => {
    // verify required parameter 'chatDomainBase' is not null or undefined
    assertParamExists('chatDomainCreate', 'chatDomainBase', chatDomainBase)
    const localVarPath = `/chat_domain`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'POST', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelChatDomainBase(chatDomainBase), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Smazat konkrétní doménu CHAT_DOMAIN podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const chatDomainDelete = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('chatDomainDelete', 'id', id)
    const localVarPath = `/chat_domain/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'DELETE', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat konkrétní CHAT_DOMAIN podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const chatDomainGet = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('chatDomainGet', 'id', id)
    const localVarPath = `/chat_domain/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat všechny CHAT_DOMAINs (domény)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const chatDomainList = (options: any = {}): any => {
    const localVarPath = `/chat_domain`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Aktualizovat konkrétní CHAT_DOMAIN podle ID
 * @param {number} id Identifikátor entity
 * @param {ChatDomainBase} chatDomainBase 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const chatDomainUpdate = (id: number, chatDomainBase: ChatDomainBase, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('chatDomainUpdate', 'id', id)
    // verify required parameter 'chatDomainBase' is not null or undefined
    assertParamExists('chatDomainUpdate', 'chatDomainBase', chatDomainBase)
    const localVarPath = `/chat_domain/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'PUT', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelChatDomainBase(chatDomainBase), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získání konfigurace pro daného zákazníka
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const configChatbotList = (options: any = {}): any => {
    const localVarPath = `/configChatbot`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Úprava konfigurace pro daného zákazníka
 * @param {ConfigChatbot} configChatbot 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const configChatbotUpdate = (configChatbot: ConfigChatbot, options: any = {}): any => {
    // verify required parameter 'configChatbot' is not null or undefined
    assertParamExists('configChatbotUpdate', 'configChatbot', configChatbot)
    const localVarPath = `/configChatbot`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'PUT', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelConfigChatbot(configChatbot), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Prirazeni konverzace operatorovi
 * @param {string} sessionId Stringový identifikátor entity
 * @param {InlineObject} inlineObject 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const conversationAssign = (sessionId: string, inlineObject: InlineObject, options: any = {}): any => {
    // verify required parameter 'sessionId' is not null or undefined
    assertParamExists('conversationAssign', 'sessionId', sessionId)
    // verify required parameter 'inlineObject' is not null or undefined
    assertParamExists('conversationAssign', 'inlineObject', inlineObject)
    const localVarPath = `/conversation/assign/{sessionId}`
        .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'PUT', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelInlineObject(inlineObject), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat všechny konverzace
 * @param {string} sessionId Stringový identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const conversationDetail = (sessionId: string, options: any = {}): any => {
    // verify required parameter 'sessionId' is not null or undefined
    assertParamExists('conversationDetail', 'sessionId', sessionId)
    const localVarPath = `/conversation/{sessionId}`
        .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat všechny konverzace
 * @param {'assign' | 'live' | 'closed' | 'all'} [filter] Filtrovani konverzaci (cekajici na prirazeni, zive konverzace, ukoncene konverzace, vsechny konverzace)
 * @param {string} [user] Filtrovani konverzaci podle jmena uzivatele
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const conversationsList = (filter?: 'assign' | 'live' | 'closed' | 'all', user?: string, options: any = {}): any => {
    const localVarPath = `/conversation`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;

    if (filter !== undefined) {
        localVarQueryParameter['filter'] = filter;
    }

    if (user !== undefined) {
        localVarQueryParameter['user'] = user;
    }


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Vytvořit nový CS_LP_UZEL uzel
 * @param {CsLpUzelCreate} csLpUzelCreate 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const csLpUzelCreate = (csLpUzelCreate: CsLpUzelCreate, options: any = {}): any => {
    // verify required parameter 'csLpUzelCreate' is not null or undefined
    assertParamExists('csLpUzelCreate', 'csLpUzelCreate', csLpUzelCreate)
    const localVarPath = `/cs_lp_uzel`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'POST', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelCsLpUzelCreate(csLpUzelCreate), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Smazat konkrétní CS_LP_UZEL uzel podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const csLpUzelDelete = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('csLpUzelDelete', 'id', id)
    const localVarPath = `/cs_lp_uzel/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'DELETE', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat konkrétní CS_LP_UZEL uzel podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const csLpUzelGet = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('csLpUzelGet', 'id', id)
    const localVarPath = `/cs_lp_uzel/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat všechny CS_LP_UZEL uzly rozhodovacího stromu
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const csLpUzelList = (options: any = {}): any => {
    const localVarPath = `/cs_lp_uzel`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Aktualizovat konkrétní CS_LP_UZEL uzel podle ID
 * @param {number} id Identifikátor entity
 * @param {CsLpUzelUpdate} csLpUzelUpdate 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const csLpUzelUpdate = (id: number, csLpUzelUpdate: CsLpUzelUpdate, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('csLpUzelUpdate', 'id', id)
    // verify required parameter 'csLpUzelUpdate' is not null or undefined
    assertParamExists('csLpUzelUpdate', 'csLpUzelUpdate', csLpUzelUpdate)
    const localVarPath = `/cs_lp_uzel/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'PUT', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelCsLpUzelUpdate(csLpUzelUpdate), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Vytvořit novou odpověď FAQ
 * @param {FaqBase} faqBase 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const faqCreate = (faqBase: FaqBase, options: any = {}): any => {
    // verify required parameter 'faqBase' is not null or undefined
    assertParamExists('faqCreate', 'faqBase', faqBase)
    const localVarPath = `/faq`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'POST', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelFaqBase(faqBase), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Smazat konkrétní odpověď FAQ podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const faqDelete = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('faqDelete', 'id', id)
    const localVarPath = `/faq/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'DELETE', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat konkrétní odpověď FAQ podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const faqGet = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('faqGet', 'id', id)
    const localVarPath = `/faq/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat všechny odpovědi FAQ
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const faqList = (options: any = {}): any => {
    const localVarPath = `/faq`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Vytvořit novou otázku FAQ_QUESTIONS
 * @param {FaqQuestionsBase} faqQuestionsBase 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const faqQuestionCreate = (faqQuestionsBase: FaqQuestionsBase, options: any = {}): any => {
    // verify required parameter 'faqQuestionsBase' is not null or undefined
    assertParamExists('faqQuestionCreate', 'faqQuestionsBase', faqQuestionsBase)
    const localVarPath = `/faq_questions`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'POST', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelFaqQuestionsBase(faqQuestionsBase), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Smazat konkrétní otázku FAQ_QUESTIONS podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const faqQuestionDelete = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('faqQuestionDelete', 'id', id)
    const localVarPath = `/faq_questions/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'DELETE', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat konkrétní otázku FAQ_QUESTIONS podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const faqQuestionGet = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('faqQuestionGet', 'id', id)
    const localVarPath = `/faq_questions/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Aktualizovat konkrétní otázku FAQ_QUESTIONS podle ID
 * @param {number} id Identifikátor entity
 * @param {FaqQuestionsBase} faqQuestionsBase 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const faqQuestionUpdate = (id: number, faqQuestionsBase: FaqQuestionsBase, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('faqQuestionUpdate', 'id', id)
    // verify required parameter 'faqQuestionsBase' is not null or undefined
    assertParamExists('faqQuestionUpdate', 'faqQuestionsBase', faqQuestionsBase)
    const localVarPath = `/faq_questions/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'PUT', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelFaqQuestionsBase(faqQuestionsBase), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat všechny otázky FAQ_QUESTIONS
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const faqQuestionsList = (options: any = {}): any => {
    const localVarPath = `/faq_questions`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Aktualizovat konkrétní odpověď FAQ podle ID
 * @param {number} id Identifikátor entity
 * @param {FaqBase} faqBase 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const faqUpdate = (id: number, faqBase: FaqBase, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('faqUpdate', 'id', id)
    // verify required parameter 'faqBase' is not null or undefined
    assertParamExists('faqUpdate', 'faqBase', faqBase)
    const localVarPath = `/faq/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'PUT', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelFaqBase(faqBase), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Vytvořit novou odpověď forb
 * @param {ForbBase} forbBase 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const forbCreate = (forbBase: ForbBase, options: any = {}): any => {
    // verify required parameter 'forbBase' is not null or undefined
    assertParamExists('forbCreate', 'forbBase', forbBase)
    const localVarPath = `/forb`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'POST', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelForbBase(forbBase), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Smazat konkrétní odpověď forb podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const forbDelete = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('forbDelete', 'id', id)
    const localVarPath = `/forb/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'DELETE', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat konkrétní odpověď forb podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const forbGet = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('forbGet', 'id', id)
    const localVarPath = `/forb/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat všechny odpovědi forb
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const forbList = (options: any = {}): any => {
    const localVarPath = `/forb`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Vytvořit novou odpověď forb_questions
 * @param {ForbQuestionBase} forbQuestionBase 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const forbQuestionCreate = (forbQuestionBase: ForbQuestionBase, options: any = {}): any => {
    // verify required parameter 'forbQuestionBase' is not null or undefined
    assertParamExists('forbQuestionCreate', 'forbQuestionBase', forbQuestionBase)
    const localVarPath = `/forb_questions`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'POST', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelForbQuestionBase(forbQuestionBase), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Smazat konkrétní odpověď forb_questions podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const forbQuestionDelete = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('forbQuestionDelete', 'id', id)
    const localVarPath = `/forb_questions/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'DELETE', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat konkrétní odpověď forb_questions podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const forbQuestionGet = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('forbQuestionGet', 'id', id)
    const localVarPath = `/forb_questions/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat všechny odpovědi forb_questions
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const forbQuestionList = (options: any = {}): any => {
    const localVarPath = `/forb_questions`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Aktualizovat konkrétní odpověď forb_questions podle ID
 * @param {number} id Identifikátor entity
 * @param {ForbQuestionBase} forbQuestionBase 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const forbQuestionUpdate = (id: number, forbQuestionBase: ForbQuestionBase, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('forbQuestionUpdate', 'id', id)
    // verify required parameter 'forbQuestionBase' is not null or undefined
    assertParamExists('forbQuestionUpdate', 'forbQuestionBase', forbQuestionBase)
    const localVarPath = `/forb_questions/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'PUT', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelForbQuestionBase(forbQuestionBase), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Aktualizovat konkrétní odpověď forb podle ID
 * @param {number} id Identifikátor entity
 * @param {ForbBase} forbBase 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const forbUpdate = (id: number, forbBase: ForbBase, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('forbUpdate', 'id', id)
    // verify required parameter 'forbBase' is not null or undefined
    assertParamExists('forbUpdate', 'forbBase', forbBase)
    const localVarPath = `/forb/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'PUT', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelForbBase(forbBase), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Vytvořit novou odpověď SMALLTALK
 * @param {SmalltalkBase} smalltalkBase 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const smalltalkCreate = (smalltalkBase: SmalltalkBase, options: any = {}): any => {
    // verify required parameter 'smalltalkBase' is not null or undefined
    assertParamExists('smalltalkCreate', 'smalltalkBase', smalltalkBase)
    const localVarPath = `/smalltalk`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'POST', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelSmalltalkBase(smalltalkBase), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Smazat konkrétní odpověď SMALLTALK podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const smalltalkDelete = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('smalltalkDelete', 'id', id)
    const localVarPath = `/smalltalk/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'DELETE', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat konkrétní odpověď SMALLTALK podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const smalltalkGet = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('smalltalkGet', 'id', id)
    const localVarPath = `/smalltalk/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat všechny odpovědi SMALLTALK
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const smalltalkList = (options: any = {}): any => {
    const localVarPath = `/smalltalk`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Vytvořit novou otázku SMALLTALK_QUESTIONS
 * @param {SmalltalkQuestionBase} smalltalkQuestionBase 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const smalltalkQuestionCreate = (smalltalkQuestionBase: SmalltalkQuestionBase, options: any = {}): any => {
    // verify required parameter 'smalltalkQuestionBase' is not null or undefined
    assertParamExists('smalltalkQuestionCreate', 'smalltalkQuestionBase', smalltalkQuestionBase)
    const localVarPath = `/smalltalk_questions`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'POST', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelSmalltalkQuestionBase(smalltalkQuestionBase), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Smazat konkrétní otázku SMALLTALK_QUESTIONS podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const smalltalkQuestionDelete = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('smalltalkQuestionDelete', 'id', id)
    const localVarPath = `/smalltalk_questions/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'DELETE', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat konkrétní otázku SMALLTALK_QUESTIONS podle ID
 * @param {number} id Identifikátor entity
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const smalltalkQuestionGet = (id: number, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('smalltalkQuestionGet', 'id', id)
    const localVarPath = `/smalltalk_questions/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Aktualizovat konkrétní otázku SMALLTALK_QUESTIONS podle ID
 * @param {number} id Identifikátor entity
 * @param {SmalltalkQuestionBase} smalltalkQuestionBase 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const smalltalkQuestionUpdate = (id: number, smalltalkQuestionBase: SmalltalkQuestionBase, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('smalltalkQuestionUpdate', 'id', id)
    // verify required parameter 'smalltalkQuestionBase' is not null or undefined
    assertParamExists('smalltalkQuestionUpdate', 'smalltalkQuestionBase', smalltalkQuestionBase)
    const localVarPath = `/smalltalk_questions/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'PUT', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelSmalltalkQuestionBase(smalltalkQuestionBase), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Získat všechny otázky SMALLTALK_QUESTIONS
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const smalltalkQuestionsList = (options: any = {}): any => {
    const localVarPath = `/smalltalk_questions`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'GET', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Aktualizovat konkrétní odpověď SMALLTALK podle ID
 * @param {number} id Identifikátor entity
 * @param {SmalltalkBase} smalltalkBase 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const smalltalkUpdate = (id: number, smalltalkBase: SmalltalkBase, options: any = {}): any => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('smalltalkUpdate', 'id', id)
    // verify required parameter 'smalltalkBase' is not null or undefined
    assertParamExists('smalltalkUpdate', 'smalltalkBase', smalltalkBase)
    const localVarPath = `/smalltalk/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'PUT', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(modelSmalltalkBase(smalltalkBase), localVarRequestOptions)

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}
/**
 * 
 * @summary Odhlaseni uzivatele
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export const uzivatelOdhlaseni = (options: any = {}): any => {
    const localVarPath = `/uzivatel/odhlaseni`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

    const localVarRequestOptions = { method: 'PUT', ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    //await setBearerAuthToObject(localVarHeaderParameter)
    localVarRequestOptions.withToken = true;


    
    setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        ...localVarRequestOptions,
    };
}



